import { StringManipulator } from '../../BGMaskedInput/utils/StringManipulator';
import { IMaskedResult, IMaskedFunc, IGeneralOptions } from '../../interfaces';
import { keyType, getKeyType } from '../../BGMaskedInput/utils/keyType';

export interface IAmountOptions extends IGeneralOptions {
    integerMaxLength: number;
    currencyPrecision: number;
}

export const amountMask: IMaskedFunc<IAmountOptions> = (
    prevText,
    prevCaretPlace,
    newKey,
    options,
) => {
    const result: IMaskedResult = {
        newText: prevText,
        newCaretPlace: prevCaretPlace,
        prevent: true,
    };
    const prevLength = prevText.length;
    const prevIntLength = prevText.indexOf('.');
    const inDecimal = prevIntLength < prevCaretPlace;
    const caretdistancefromDot = prevCaretPlace - prevText.indexOf('.') - 1;
    const manipulator = new StringManipulator(prevText, newKey);

    switch (getKeyType(newKey)) {
        case keyType.number:
            if (!inDecimal && prevIntLength < options.integerMaxLength) {
                if (prevText.charAt(0) === '0' && prevCaretPlace === 1) {
                    result.newText = manipulator.reset().replaceNewCharAt(0).text;
                    result.newCaretPlace = 1;
                } else {
                    result.newText = manipulator.reset().insertNewCharAt(prevCaretPlace).text;
                    result.newCaretPlace = prevCaretPlace + 1;
                }
            } else if (inDecimal && caretdistancefromDot < options.currencyPrecision) {
                result.newText = manipulator.reset().cutTail().insertNewCharAt(prevCaretPlace).text;
                result.newCaretPlace = prevCaretPlace + 1;
            }

            return result;

        case keyType.backspace:
            if (inDecimal) {
                if (prevText.charAt(prevCaretPlace - 1) === '.') {
                    result.newCaretPlace = prevCaretPlace - 1;
                } else {
                    result.newText = manipulator
                        .reset()
                        .removeCharAt(prevCaretPlace - 1)
                        .insertCharAt('0', prevLength).text;
                    result.newCaretPlace = prevCaretPlace - 1;
                }
            } else if (prevCaretPlace === 1 && prevIntLength === 1) {
                result.newText = manipulator.reset().replaceCharAt('0', 0).text;
                result.newCaretPlace = 1;
            } else {
                result.newText = manipulator.reset().removeCharAt(prevCaretPlace - 1).text;
                result.newCaretPlace = prevCaretPlace - 1;
            }
            return result;

        case keyType.separator: {
            result.newCaretPlace = prevText.indexOf('.') + 1;
            return result;
        }

        case keyType.caretMove:
            result.prevent = false;
            return result;

        default:
            return result;
    }
};
